//common

export const getDeliveryEnabledData = common =>
  common &&
  common.config &&
  common.config.order &&
  common.config.order.delivery &&
  common.config.order.delivery.enabled
    ? common.config.order.delivery.enabled
    : false;

export const getOccupationData = common =>
  common && common.item ? common.item : null;

export const getTopUpItemData = common =>
  common &&
  common.config &&
  common.config.top_up &&
  common.config.top_up.ipay &&
  common.config.top_up.ipay.items
    ? common.config.top_up.ipay.items
    : false;

export const getTopUpAmount = common =>
  common && common.amount ? common.amount : false;

export const getTopUpSummary = common =>
  common && common.summary && common.summary.items
    ? common.summary.items
    : false;

export const getTopUpPayment = common =>
  common && common.payment ? common.payment : false;



// WEBPACK FOOTER //
// ./src/selectors/common.js